import { useState } from "react";
import { Box, Button, Grid, Paper, TextField, Typography } from "@mui/material";
import { isAuthenticated, addPlan } from "../../../ApiService/ApiService";
import { ArrowBack, ArrowForward } from "@mui/icons-material";
import CustomDialog from "../../../Components/CustomDialog";

function AddPlan({ fetchPlans, setShowAddPlans }) {
  const [formData, setFormData] = useState({
    name: "",
    amount: "",
    duration: "",
  });
  const [loading, setLoading] = useState(false);
  const [dialog, setDialog] = useState({
    visible: false,
    title: "",
    message: "",
    buttons: [],
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleDialogClose = () => {
    setDialog({ ...dialog, visible: false });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name || !formData.amount || !formData.duration) {
      setDialog({
        visible: true,
        title: "Error",
        message: "Please fill all the details",
        buttons: [{ name: "Close", onPress: handleDialogClose }],
      });
      return;
    }
    setLoading(true);
    try {
      if (isAuthenticated()) {
        const response = await addPlan(formData);
        // console.log("RES", response?.data);
        if (response) {
          if (response?.data?.status === 200) {
            setDialog({
              visible: true,
              title: "Success",
              message: "Plan added",
              buttons: [{ name: "OK", onPress: handleDialogClose }],
            });
            setFormData({
              name: "",
              amount: "",
              duration: "",
            });
            fetchPlans();
            setShowAddPlans(false);
          } else {
            const errorMessage = response?.data?.errorMessage;
            setDialog({
              visible: true,
              title: "Error",
              message: errorMessage,
              buttons: [{ name: "Close", onPress: handleDialogClose }],
            });
          }
        } else {
          setDialog({
            visible: true,
            title: "Error",
            message: "Invalid response from the server",
            buttons: [{ name: "Close", onPress: handleDialogClose }],
          });
        }
      } else {
        setDialog({
          visible: true,
          title: "Unauthorized action",
          message: "Please login and try again",
          buttons: [{ name: "Close", onPress: handleDialogClose }],
        });
        return;
      }
    } catch (error) {
      setDialog({
        visible: true,
        title: "Error",
        message: "Failed to add plan",
        buttons: [{ name: "Close", onPress: handleDialogClose }],
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <CustomDialog
        visible={dialog.visible}
        title={dialog.title}
        message={dialog.message}
        buttons={dialog.buttons}
        onClose={handleDialogClose}
      />
      <Box sx={{ maxWidth: "75%", margin: "auto", padding: 3 }}>
        <Paper elevation={3} sx={{ padding: 5 }}>
          <Typography
            variant="h6"
            gutterBottom
            sx={{ fontWeight: 600, fontSize: 22, color: "black" }}
          >
            Add Plan
          </Typography>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Plan Name"
                  name="name"
                  type="text"
                  value={formData.name}
                  onChange={handleChange}
                  size="small"
                  required
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Amount"
                  name="amount"
                  value={formData.amount}
                  onChange={handleChange}
                  size="small"
                  required
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <TextField
                  fullWidth
                  label="Duration"
                  name="duration"
                  value={formData.duration}
                  onChange={handleChange}
                  size="small"
                  required
                  helperText="*Enter the duration in Days"
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                {" "}
                <Button
                  fullWidth
                  variant="contained"
                  color="inherit"
                  onClick={() => setShowAddPlans(false)}
                  startIcon={<ArrowBack />}
                  sx={{ textTransform: "unset" }}
                >
                  Back
                </Button>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                {" "}
                <Button
                  fullWidth
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={loading}
                  endIcon={<ArrowForward />}
                  sx={{ textTransform: "unset" }}
                >
                  {loading ? "Loading..." : "Submit"}
                </Button>
              </Grid>
            </Grid>
          </form>
        </Paper>
      </Box>
    </>
  );
}

export default AddPlan;
